// ===============================
// pages/Deals.jsx
// ===============================

import React from "react";
import "./Deals.css";

const deals = [
  {
    id: 1,
    name: "Bluetooth Speaker",
    oldPrice: "₹2499",
    newPrice: "₹1799",
    image:
      "https://images.unsplash.com/photo-1585386959984-a4155224a1ad",
  },
  {
    id: 2,
    name: "Sneakers",
    oldPrice: "₹2999",
    newPrice: "₹1999",
    image:
      "https://images.unsplash.com/photo-1542291026-7eec264c27ff",
  },
];

const Deals = () => {
  return (
    <div className="deals-page">

      <div className="page-banner">
        <h1>Best Deals</h1>
      </div>

      <div className="container deals-grid">

        {deals.map((item) => (

          <div
            className="deal-card"
            key={item.id}
          >

            <img
              src={item.image}
              alt={item.name}
            />

            <div className="deal-info">
              <h3>{item.name}</h3>

              <div className="price-box">
                <span className="old">
                  {item.oldPrice}
                </span>

                <span className="new">
                  {item.newPrice}
                </span>
              </div>

              <button>
                Shop Now
              </button>
            </div>

          </div>

        ))}

      </div>

    </div>
  );
};

export default Deals;